import { Box } from '@chakra-ui/react';
import moment from 'moment';

import { TextRegular } from 'UiKit/typography';

import ColumnStartLivestream from 'View/report-attendance-host-detail/component/column-start-livestream';
import AttachmentImage from 'Component/attachment-image';

import styles from './styles.module.css';

export const tableList = (onOpenPreview, t) => [
  {
    name: t('columnLivestreamDetail.no'),
    key: 'index',
    position: 'left',
    width: '50px',
    component: ({ index }) => {
      return <TextRegular className={`${styles['modal__table--col-text']}`}>{index + 1}</TextRegular>;
    },
  },
  {
    name: t('columnLivestreamDetail.photoProof'),
    key: 'images',
    position: 'left',
    width: '90px',
    component: ({ value }) => {
      const images = (value || []).map((item) => ({ url: item.url, caption: item.caption }));
      return (
        <Box className={styles['modal__table--col-image']}>
          <AttachmentImage images={images} onOpenPreview={onOpenPreview} />
        </Box>
      );
    },
  },
  {
    name: t('columnLivestreamDetail.startLivestream'),
    key: 'startLive',
    position: 'left',
    width: '180px',
    component: ({ value }) => {
      return <ColumnStartLivestream value={value} />;
    },
  },
  {
    name: t('columnLivestreamDetail.endLivestream'),
    key: 'endTime',
    position: 'left',
    width: '180px',
    component: ({ value }) => {
      return <TextRegular className={`${styles['modal__table--col-text']}`}>{value !== '-' ? moment(value).format('HH:mm:ss DD/MM/YY') : value}</TextRegular>;
    },
  },
  {
    name: t('columnLivestreamDetail.startLiveNote'),
    key: 'startNote',
    position: 'left',
    width: '200px',
    component: ({ value }) => {
      return <TextRegular className={`${styles['modal__table--col-text']}`}>{value || '-'}</TextRegular>;
    },
  },
  {
    name: t('columnLivestreamDetail.endLiveNote'),
    key: 'endNote',
    position: 'left',
    width: '200px',
    component: ({ value }) => {
      return <TextRegular className={`${styles['modal__table--col-text']}`}>{value || '-'}</TextRegular>;
    },
  },
];
export default tableList;
